import { MouseEvent } from 'react';
import { linkTrackEvent } from '~/adapters/tracking/tracking';

export const gaCategory = 'Account Orders';

export const orderLinkTrackEvent = (event: MouseEvent<HTMLElement>, label: string): void =>
    linkTrackEvent(event, { action: 'accounts order', label });

export const orderLinkTrackEventV2 = (event: MouseEvent<HTMLElement>, label: string) =>
    linkTrackEvent(event, {
        event: 'interaction',
        action: '',
        label,
        customMetrics: {
            interaction_type: 'button_click',
            interaction_location: 'order_history',
            event: 'accounts_interaction',
        },
    });
